<template>
    <v-container>
        <v-sheet>
            <v-img src="/safesytelogo-tagline.png" width="60%" class="mx-auto"></v-img>
        </v-sheet>

        <v-row>
            <v-col cols="10" offset="1" >
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Impedit nesciunt obcaecati minus qui assumenda, eius veritatis itaque provident sit minima voluptatibus necessitatibus voluptatem doloremque saepe soluta temporibus explicabo, ut deserunt.
            </v-col>
        </v-row>

    </v-container>
</template>

<script>
export default {
    
}
</script>